const client_id = encodeURIComponent(process.env.VUE_APP_OPEN_CONNECT_CLIENT_ID);
const redirect_uri = encodeURIComponent(process.env.VUE_APP_REDIRECT_URI);
export const open_connect_auth = process.env.VUE_APP_OPEN_CONNECT_AUTH;
export const urlLogoutOpenConnectId = process.env.VUE_APP_OPEN_CONNECT_LOGOUT;

const scope = encodeURIComponent("openid legado profile");
const response_type = encodeURIComponent("code");

export const openConnectURI = `${open_connect_auth}?scope=${scope}&response_type=${response_type}&client_id=${client_id}&redirect_uri=${redirect_uri}`;